import React from "react";
import logger from "logger";

import AccountDetailsSection from "TaskHistory/Tasklet/SubTasklets/AccountDetailsSection.js";
import StatusSection from "TaskHistory/Tasklet/SubTasklets/StatusSection.js";
import ErrorLogsSection from "TaskHistory/Tasklet/SubTasklets/ErrorLogsSection.js";
import ActionsSection from "TaskHistory/Tasklet/SubTasklets/ActionsSection.js";
import TaskletCard from "./TaskletCard";
import CardContent from "@material-ui/core/CardContent";
import { StringMap } from "./StringMap";
import { StringValue } from "./StringValue";
import { getTroopNameFromId } from "Utils/Common";

export default function(props) {
  const { task } = props;

  return (
    <TaskletCard title="Trainathon">
      <CardContent>
        <AccountDetailsSection
          task={task}
          showOwner={props.showOwner}
          showUser={props.showUser}
        />
        <StringValue
          label={"Auto Unbox Troops?"}
          value={task.taskstatusdetail.unboxtroops}
        />
        <StringValue
          label={"Tat Type and City"}
          value={`${task.taskstatusdetail.selectedtattype}(
          ${task.taskstatusdetail.selectedcity.cname})`}
        />
        <StringValue
          label={"Train Troop/Dismiss Troop"}
          value={`${getTroopNameFromId(task.taskstatusdetail.selectedtroop)}/
          ${getTroopNameFromId(task.taskstatusdetail.dismisstroop)}`}
        />
        <StringValue
          label={"Speed in secs"}
          value={task.taskstatusdetail.speedinsecs}
        />
        <StatusSection task={task} />
        {task.taskstatusdetail.smaughit && (
          <>
            <StringValue label={"Smaug Hit"} value={"Yes"} />
            <StringValue
              label={"Smaug Hit Per Queue"}
              value={task.taskstatusdetail.shperqueue}
            />
            <StringValue
              label={"Smaug Hit Hero"}
              value={task.taskstatusdetail.selectedhero.heroname}
            />
            <StringMap
              label={"Smaug Hit Troops"}
              valueMap={task.taskstatusdetail.troops}
              valueParser={(k, v) => (
                <>
                  {getTroopNameFromId(k)}: {v}
                </>
              )}
            />
          </>
        )}
        <StringValue
          label={"Queues done"}
          value={`${task.taskstatusdetail.totalqueuesdone}/
          ${task.taskstatusdetail.noOfHits}`}
        />
        <ErrorLogsSection task={task} />
      </CardContent>
      <ActionsSection task={task} />
    </TaskletCard>
  );
}
